import { PAYMENT_TYPE } from '../enum/Enum';
import { Context } from './quote';

export class RegisterPurchase {
  contexts: Context[];
  paymentMethod: string;
  paymentSystemParams: any;
  creditCardStorage: boolean;
  creditCardStorageForRenewal: boolean
  amazonAccessToken?: string;
  amazonOrderReferenceId: any;

  constructor(data: any, payment: string, paymentSystemParams: any, amazonAccessToken?: string,
              orderReferenceId?: any, event?: any) {
    if (data.context) {
      this.contexts = [data.context];
    }
    else {
      this.contexts = data && data.contexts ? data.contexts : null;
    }
    this.paymentMethod = PAYMENT_TYPE[payment];
    this.paymentSystemParams = paymentSystemParams;

    if (event && event.allowCreditCardStorage) {
      this.creditCardStorage = event.acceptSave;
    } else {
      this.creditCardStorage = false;
    }

    if (event && event.allowCreditCardStorageForRenewal) {
      this.creditCardStorageForRenewal = event.acceptSave;
    } else {
      this.creditCardStorageForRenewal = false;
    }

    this.amazonAccessToken = amazonAccessToken;
    this.amazonOrderReferenceId = orderReferenceId;
  }
}
